import { Product } from '../../types/Product';
import { EXCLUDED_PRODUCTS, ALLOWED_FOODS } from './constants';

export const filterBabyProducts = (products: Product[], ageRange: string): Product[] => {
  const allowedFoods = ALLOWED_FOODS[ageRange as keyof typeof ALLOWED_FOODS];
  if (!allowedFoods) return [];

  return products.filter(product => {
    const name = product.display_name.toLowerCase();
    const category = product.category_name.toLowerCase();

    // First exclude inappropriate items
    if (EXCLUDED_PRODUCTS.some(term => name.includes(term) || category.includes(term))) {
      return false;
    }

    // Check if it's a baby-specific product
    if (name.includes('bebé') || name.includes('infantil') || 
        name.includes('potito') || name.includes('papilla')) {
      return true;
    }

    // Check against allowed foods for this age range
    return Object.values(allowedFoods).some(foodGroup =>
      foodGroup.some(food => {
        if (food === 'todas') return true;
        return name.includes(food) || category.includes(food);
      })
    );
  });
};